import React from 'react'
import useIconSize from '../icon-size'
import IconPropTypes from '../IconPropTypes'

function IconAlert({ size, ...props }) {
  const sizeValue = useIconSize(size)
  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.221 15.131c.274.334.49.632.648.892.157.261.173.522.047.783a.773.773 0 01-.616.454 4.888 4.888 0 01-.663.063h-2.952a2.57 2.57 0 01-.79 1.894 2.613 2.613 0 01-1.91.783c-.746 0-1.383-.26-1.91-.783a2.57 2.57 0 01-.789-1.894H6.398c-.242 0-.492-.029-.75-.086a.788.788 0 01-.56-.43c-.127-.262-.116-.53.031-.807.147-.277.347-.582.6-.916.284-.365.594-.78.931-1.245.337-.464.505-.947.505-1.448V9.12c0-.71.124-1.375.371-1.996a5.184 5.184 0 011.019-1.628c.431-.464.941-.83 1.53-1.096a4.558 4.558 0 011.895-.399c.684 0 1.32.133 1.91.4.59.265 1.102.63 1.54 1.095a5.11 5.11 0 011.025 1.628c.248.621.371 1.287.371 1.996v3.272c0 .512.16 1.008.482 1.488.32.48.629.897.923 1.252zm-6.237 3.78c.427 0 .792-.15 1.095-.451.302-.3.454-.662.454-1.085h-3.097c0 .423.151.785.454 1.085.303.3.667.45 1.094.45zm5.594-2.822a5.039 5.039 0 00-.168-.22 14.96 14.96 0 01-1.232-1.673 3.373 3.373 0 01-.544-1.864V9.153c0-.547-.094-1.06-.283-1.536a3.993 3.993 0 00-.773-1.247 3.668 3.668 0 00-1.155-.844 3.367 3.367 0 00-1.446-.312c-.51 0-.988.104-1.431.312-.444.208-.83.489-1.156.844-.326.355-.581.77-.765 1.247a4.236 4.236 0 00-.276 1.536v3.18a3.12 3.12 0 01-.573 1.817 48.208 48.208 0 01-1.21 1.68 4.714 4.714 0 00-.175.26h11.187z"
        clipRule="evenodd"
      />
    </svg>
  )
}

IconAlert.propTypes = IconPropTypes
export default IconAlert
